import { render, staticRenderFns } from "./AdsLeCard.vue?vue&type=template&id=0bd99dca&scoped=true"
import script from "./AdsLeCard.vue?vue&type=script&lang=js"
export * from "./AdsLeCard.vue?vue&type=script&lang=js"
import style0 from "./AdsLeCard.vue?vue&type=style&index=0&id=0bd99dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd99dca",
  null
  
)

export default component.exports